export const contactInfo = {
  email: "info@mit4doctors.com",
  emailHref: "mailto:info@mit4doctors.com",
  phone: "(615) 747-1900",
  phoneHref: "tel:+16157471900",
  address: {
    line1: "1616 Westgate Circle",
    line2: "Brentwood TN, 37027",
    full: "1616 Westgate Circle, Brentwood TN, 37027",
    mapHref:
      "https://maps.app.goo.gl/fUT6DoNdborVPuAD7",
  },
};

export default contactInfo;
